import {PWMAT_RESOURCE} from './consts'

export const ModuleClass = [
  {
    name: '1.结合主动学习: PWmat_MLFF扩展应用MLFF on the fly',
    url: 'https://mp.weixin.qq.com/s/4MXeBHojatqoAWAcGp946w',
  },
  {
    name: '2.“光”怪陆离：PWmat计算光学性质（三）',
    url: 'https://mp.weixin.qq.com/s/URFZYjX1iHFp2T-m-7LkZw',
  },
  {
    name: '3.“光”怪陆离：PWmat计算光学性质（二）',
    url: 'https://mp.weixin.qq.com/s/NfLL1Ex4Zajlrj0QZiPjKQ',
  },
  {
    name: '4.“光”怪陆离：PWmat计算光学性质（一）',
    url: 'https://mp.weixin.qq.com/s/mtrAPVbTMqB9npEpqV_cmA',
  },
  {
    name: '5.浅谈对gap的认识：PWmat中修正gap的module',
    url: 'https://mp.weixin.qq.com/s/9jkQ9u58g949gfK94FMw3g',
  },
  {
    name: '6.高端、大气、上档次的CPM方法原理介绍以及应用实例',
    url: 'https://mp.weixin.qq.com/s/NCRQX5OqCMTCR02H1FvTTg',
  },
  {
    name: '7.LDA+U中U值的计算方法',
    url: 'https://mp.weixin.qq.com/s/xMCSsHJMFNn3nCM6jSx05A',
  },
  {
    name: '8.high-k gate stacks的重要研究成果',
    url: 'https://mp.weixin.qq.com/s/pKxb9vslOWNe5uMC3HlI-A',
  },
  {
    name: '9.不依赖于半导体维度的带电缺陷计算方法',
    url: 'https://mp.weixin.qq.com/s/zROfXW8VThopMS0v7yUT3w',
  },
  {
    name: '10.布拜图（Pourbaix Diagram）计算',
    url: 'https://mp.weixin.qq.com/s/CqmB3PKtP3NnRj2p9J9oiA',
  },
  {
    name: '11. PWmat计算晶态硅与非晶硅界面电荷俘获过程',
    url: 'https://mp.weixin.qq.com/s/w8entgtW-_vxW9ivEJhEeg',
  },
  {
    name: '12. Wannier Koopmans Method修正LDA带隙',
    url: 'https://mp.weixin.qq.com/s/5ZXBO6LxDAUrg-EZggIqMw',
  },
  {
    name: '13. NAMD研究Au/GaN体系中超快热载流子注入',
    url: 'https://mp.weixin.qq.com/s/LZZEttScCo8kAZlf2C40sw',
  },
  {
    name: '14. PWmat固定电势法(fixed-potential method)的计算思路',
    url: 'https://mp.weixin.qq.com/s/ssNGXChznpNiPABJAJR5Lw',
  },
  {
    name: '15. WKM方法准确计算二维材料的能带结构',
    url: 'https://mp.weixin.qq.com/s/flfDEpLrHt94i7jRjhzZgA',
  },
  {
    name: '16. 非绝热分子动力学（NAMD）研究量子点中热载流子弛豫和转移过程',
    url: 'https://mp.weixin.qq.com/s/IecSYcfh-DBUSdTUV85Gaw',
  },
  {
    name: '17. Wannier-Koopmans method （WKM）计算有机分子晶体的带隙',
    url: 'https://mp.weixin.qq.com/s/P41fTj-oI4q8ldo9eFuCvA',
  },
  {
    name: '18. 晶体、缺陷体系以及超胞中部分原子声子谱的计算',
    url: 'https://mp.weixin.qq.com/s/vqHbVbZGMMnZZFsr2Fpnlw',
  },
  {
    name: '19. PWmat module介绍之-disorder',
    url: 'https://mp.weixin.qq.com/s/fOphldP_k1lt7-wfg5-bow',
  },
  {
    name: '20. 用PWmat完成ORR催化计算',
    url: 'https://mp.weixin.qq.com/s/haVZFvYVLMmgWwqaXjVbkA',
  },
  {
    name: '21. PWmat的晶格热导率计算模块',
    url: 'https://mp.weixin.qq.com/s/Z4NLfg8WqIGFysxv5tZt7g',
  },
  {
    name: '22. PWmat——DeePMD-kit接口用于深度学习',
    url: 'https://mp.weixin.qq.com/s/JTwU-dEtBYxALQTYgMGkqA',
  },
  {
    name: '23. PWmat module介绍之-PLUMED',
    url: 'https://mp.weixin.qq.com/s/2pq8qkg_Kr7b43EKgGVOOg',
  },
  {
    name: '24. PWmat的热输运模块',
    url: 'https://mp.weixin.qq.com/s/aGIFo88rGuJNMhl_LIciHA',
  },
  {
    name: '25. PWmat module介绍之-BSE计算',
    url: 'https://mp.weixin.qq.com/s/LsrJug8FKZRSeRwgin9teQ',
  },
  {
    name: '26. 手把手教你用PWmat算电荷俘获',
    url: 'https://mp.weixin.qq.com/s/KUqp63W8itQIOjxi38wvAA',
  },
  {
    name: '27. 手把手教你用PWmat计算OER、ORR、HER反应',
    url: 'https://mp.weixin.qq.com/s/FI5VnpgT3Wa2KO5uKqFVYA',
  },
  {
    name: '28. PWmat推出金属体系电导率计算模块',
    url: 'https://mp.weixin.qq.com/s/V3DbrFu5HGohpl8IqYQDSw',
  },
  {
    name: '29. PWmat重磅利器——大体系计算Charge Patching Method',
    url: 'https://mp.weixin.qq.com/s/XwvkMElHgWRjhMLvFcrHrw',
  },
  {
    name: '30. PWmat的Defect Nonradiative Decay计算模块',
    url: 'https://mp.weixin.qq.com/s/B_t3cVwJR895sq-jzIk9FA',
  },
  {
    name: '31. PWmat的rt-TDDFT模块模拟超快动力学实例',
    url: 'https://mp.weixin.qq.com/s/aoaguhLXxgp1nvLuYrGXEg',
  },
  {
    name: '32. PWmat计算缺陷能级',
    url: 'https://mp.weixin.qq.com/s/dRfy7o_KZslzt3kAyCrK7g',
  },
  {
    name: '33. PWmat加入多种NEB新算法以及CI-NEB支持',
    url: 'https://mp.weixin.qq.com/s/5_1Vd8DqN-eaJDmIZE2t7Q',
  },
  {
    name: '34. PWmat加入SCAN+rVV10功能',
    url: 'https://mp.weixin.qq.com/s/gtyJNfWI8H4wPDjcMa9KAw',
  },
  {
    name: '35. PWmat支持NPT系统分子动力学',
    url: 'https://mp.weixin.qq.com/s/v5b2cN-e3Z8g0J0T5jNSAw',
  },
  {
    name: '36. PWmat推出高通量弹性常数计算模块ELPWmat',
    url: 'https://mp.weixin.qq.com/s/_WgjQQ9YmSMKQDLkScdnIQ',
  },
  {
    name: '37. PWmat实现HSE+SOC功能',
    url: 'https://mp.weixin.qq.com/s/W1IAwHvzOPNlTkCmN8wz2A',
  },
  {
    name: '38. PWmat计算能带带阶流程',
    url: 'https://mp.weixin.qq.com/s/5r4teJNfcE3cMXKtEq3wcQ',
  },
  {
    name: '39. PWmat推出专属赝势—ONCV-PWM-PBE模守恒赝势',
    url: 'https://mp.weixin.qq.com/s/y4xXZ5W3bRYezk_LYSo_mg',
  },
  {
    name: '40. PWmat实现大体系的HSE快速计算',
    url: 'https://mp.weixin.qq.com/s/zIfmHgV_cKlmrVhImOKcyg',
  },
  {
    name: '41. 用PWmat提高原子弛豫速度',
    url: 'https://mp.weixin.qq.com/s/Bx-q5V2gsnNqxEeJYI2dpw',
  },
  {
    name: '42. PWmat功能模块-Solvent Model',
    url: 'https://mp.weixin.qq.com/s/PZ-an4-DIfemiBtCSZQgxw',
  },
  {
    name: '43. 用PWmat完成电声耦合计算',
    url: 'https://mp.weixin.qq.com/s/FrYnFL0GUeWsc8X9yJ2H4w',
  },
  {
    name: '44. PWmat+CALYPSO接口应用实例',
    url: 'https://mp.weixin.qq.com/s/86le9shChRVhKMiUSiWRGw',
  },
  {
    name: '45. PWmat计算声子谱实例',
    url: 'https://mp.weixin.qq.com/s/qtt1ax6OX4SxkuCUqaepkw',
  },
  {
    name: '46. PWmat+Wannier.90准确计算带隙',
    url: 'https://mp.weixin.qq.com/s/0vaXYZlWITlcIXOOdOsR3A',
  },
  {
    name: '47. PWmat的rt-TDDFT模块研究碰撞问题',
    url: 'https://mp.weixin.qq.com/s/wIrr1Nlq-r7t0S3rnDYwuA',
  }

]


